import React, { createContext, ReactElement, ReactNode, useState } from 'react'

type GlobalModalContextActions = {
  /** Shows a global modal */
  showGlobalModal: (modal: ReactElement) => void
  /** */
  closeGlobalModal: () => void
}

type GlobalModalContextState = {
  modal?: ReactElement
}

type GlobalModalContextValue = GlobalModalContextState &
  GlobalModalContextActions

const stubGlobalModalContextActions: GlobalModalContextActions = {
  showGlobalModal: () => {
    throw Error('GlobalModalContext not initialized')
  },
  closeGlobalModal: () => {
    throw Error('GlobalModalContext not initialized')
  },
}
const defaultGlobalModalContextState: GlobalModalContextState = {}

export const GlobalModalContext = createContext<GlobalModalContextValue>({
  ...defaultGlobalModalContextState,
  ...stubGlobalModalContextActions,
})

type GlobalModalProviderProps = {
  children: ReactNode
}

export function GlobalModalProvider(
  props: GlobalModalProviderProps,
): ReactElement {
  const { children } = props
  const [globalModalState, setGlobalModalState] =
    useState<GlobalModalContextState>(defaultGlobalModalContextState)

  /*
   * TODO: We need a new globally available modal to refactor first as an example before
   * we can really make this method awesome and functional. Keeping this here for now to see if
   * this is the style we want to go with for now.
   */
  const showGlobalModal = (modal: ReactElement): void => {
    setGlobalModalState({
      modal,
    })
  }

  const closeGlobalModal = (): void => {
    setGlobalModalState({})
  }

  return (
    <GlobalModalContext.Provider
      value={{
        ...globalModalState,
        showGlobalModal,
        closeGlobalModal,
      }}
    >
      {children}
      {globalModalState?.modal}
    </GlobalModalContext.Provider>
  )
}
